var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 293.9 293.7",
    style: {
      enableBackground: "new 0 0 293.9 293.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.2,141.3c0-5.5,4.5-10,9.9-10h0.1l16.5,0.1c5.5,0,10,4.5,10,10l0,0V204c1.8-0.6,4.2-1.1,6.9-1.8 c3.8-0.9,6.4-4.2,6.4-8.1v-77.7c0-5.5,4.5-10,10-10h16.6c5.5,0,10,4.5,10,10v72.1c0,0,4.2-1.7,8.2-3.4c3-1.3,5-4.3,5.1-7.7v-86 c0-5.5,4.5-10,10-10h16.6c5.5,0,10,4.5,10,10v70.8c14.4-10.5,29-23,40.6-38c3.4-4.5,4.4-10.3,2.6-15.6 C241.6,61.9,198,30.2,148.6,29.5c-65-0.9-118.7,52.2-118.7,117.2c-0.1,20.6,5.3,40.8,15.6,58.6c2.9,5,8.4,7.8,14.1,7.3 c3.1-0.2,7-0.6,11.7-1.2c4.2-0.5,7.3-4,7.3-8.2L78.2,141.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.8,241.7c52.4,38.1,125.7,26.5,163.8-25.9c14.6-20,22.4-44.2,22.4-69c0-2.7-0.2-5.4-0.3-8 C220.9,202.7,141.8,232.6,77.8,241.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st1",
    d: "M147.5,293.7C66,293.7,0,227.6,0,146.8S66,0,147.5,0c9.8,0,19.8,1.2,29.6,3.1 c5.6,1.2,10.5,2.4,16,4.3c2.5,0.6,4.3,3.7,3.1,6.1c-0.6,2.4-3.7,4.3-6.2,3.1c-5-1.8-9.8-3.1-14.8-3.7 c-9.2-1.8-18.5-3.1-27.7-3.1C71.6,9.8,9.8,71.6,9.8,146.9s61.7,137,137.1,137S284,222.7,284,146.8c0-22.6-5.6-44.7-16-64.2 c-1.2-2.4-0.6-5.5,1.9-6.7s5.6-0.6,6.8,1.8C287.8,99.1,294,123,294,146.8C294.4,227.6,228.4,293.7,147.5,293.7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st1",
    d: "M249.7,51.4c-1.2,0-2.5-0.6-3.1-1.8c-3.1-3.7-6.8-7.3-10.6-11c-3.1-2.4-5.6-4.9-8.7-7.3 c-2.5-1.8-2.5-4.9-1.2-7.3c1.2-2.4,4.3-3.1,6.8-1.2c3.1,2.4,6.2,4.9,9.3,8c3.7,3.7,8.1,7.3,11.2,11.6c1.9,1.8,1.9,5.5,0,8 C252.2,50.8,250.9,51.4,249.7,51.4"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.d0129264e42dede463c762a01520e363.svg";
export { ForwardRef as ReactComponent };